export const ALL_STATUS = "allStatus";
export const ALL_STATUS_TEXT = "All Claims";
export const ALL_TIME = "allTime";
export const ALL_TIME_TEXT = "All Time";
export const ASSURANCE_PRODUCT_CATEGORY_SLUG = "assurance";
export const AUTHORIZATION = "authorization";

export const BUTTON_CONFIRM_AND_ISSUE_POLICY = "Confirm And Issue Policy";
export const BUTTON_COPAY = "Copay";
export const BUTTON_DASHBOARD = "Dashboard";
export const BUTTON_GO_BACK_TO_DASHBOARD = "Go Back To Dashboard";
export const BUTTON_GO_BACK_TO_REVIEW_DETAILS = "Go Back To Assurance Details";
export const BUTTON_PROCESSING = "Processing...";
export const BUTTON_SUBMIT = "Submit";
export const BUTTON_SUBMIT_CLAIM = "Submit estimate";
export const BUTTON_UPLOAD_INVOICE = "Invoice";
export const BUTTON_INVOICE_UPLOADED = "Invoice";
export const BUTTON_UPLOAD_REPAIRED_MOBILE = "Mobile";
export const BUTTON_REPAIRED_MOBILE_UPLOADED = "Mobile";
export const BUTTON_PROCESS_CLAIM = "Process";
export const BUTTON_ESTIMATE_CLAIM = "Estimate";
export const BUTTON_EDIT_ESTIMATE_CLAIM = "Edit Estimate";
export const BUTTON_REVISE_ESTIMATE_CLAIM = "Revise Estimate";

export const BUTTON_UPLOAD_DAMAGED_MOBILE = "Mobile";
export const BUTTON_INITIATE_CLAIM = "Initiate Claim";
export const BUTTON_PAYMENT_LINK = "Payment Link";
export const BUTTON_PAYMENT_PENDING = "Payment Pending";

export const CLAIM_ACKNOWLEDGEMENT = "Claim Acknowledgement";
export const CLAIMS_LISTING = "Claims Listing";
export const CLAIM_ESTIMATION = "Claim Estimate";

export const CLAIM_STATUS_INITIATED_SLUG = "claim_initiated";
export const CLAIM_STATUS_REJECTED_SLUG = "rejected";
export const CLAIM_STATUS_APPROVED_SLUG = "approved";
export const CLAIM_STATUS_INITIATED = "Initiated";
export const CLAIM_STATUS_INITIATED_SULG = "initiated";
export const CLAIM_STATUS_SUBMITTED = "claim_submitted";
export const CLAIM_STATUS_APPROVED = "Approved";
export const CLAIM_STATUS_REJECTED = "Rejected";
export const CLAIM_STATUS_SETTLED = "Deliver phone to customer";
export const CLAIM_STATUS_SETTLED_SLUG = "deliver_phone_to_customer";
export const CLAIM_STATUS_IN_PROGRESS = "Repair in progress";
export const CLAIM_STATUS_IN_PROGRESS_SLUG = "repair_in_progress";
export const CLAIM_STATUS_CLOSED_SLUG = "closed";
export const CLAIM_STATUS_CLOSED = "Closed";
export const CLAIM_STATUS_PARTIALLY_APPROVED = "partially_approved";

export const CLAIM_APPROVED_TEXT = "Approved";
export const CLAIM_DOCUMENTS_VERIFIED_TEXT = "Documents Verified";
export const CLAIM_INITIATED_TEXT = "Claim Initiated";
export const CLAIM_NEED_MORE_DOCUMENTS_TEXT = "Need more documents";
export const CLAIM_REJECTED_TEXT = "Rejected";
export const CLAIM_SETTLEMENT_COMPLETED_TEXT = "Settlement Completed";
export const CLAIM_SETTLEMENT_INITIATED_TEXT = "Settlement Initiated";
export const CLAIM_SUBMITTED_TEXT = "Claim Submitted";
export const CLAIM_CLOSED_TEXT = "Closed";
export const CLAIM_PARTIALLY_APPROVED_TEXT = "Partially Approved";

export const CLAIM_STATUS_MAPPING = {
  [CLAIM_SUBMITTED_TEXT]: CLAIM_STATUS_INITIATED,
  [CLAIM_INITIATED_TEXT]: CLAIM_STATUS_INITIATED,
  [CLAIM_NEED_MORE_DOCUMENTS_TEXT]: CLAIM_STATUS_INITIATED,
  [CLAIM_REJECTED_TEXT]: CLAIM_STATUS_REJECTED,
  [CLAIM_APPROVED_TEXT]: CLAIM_STATUS_IN_PROGRESS,
  [CLAIM_SETTLEMENT_COMPLETED_TEXT]: CLAIM_STATUS_SETTLED,
  [CLAIM_DOCUMENTS_VERIFIED_TEXT]: CLAIM_STATUS_INITIATED,
  [CLAIM_SETTLEMENT_INITIATED_TEXT]: CLAIM_STATUS_IN_PROGRESS,
  [CLAIM_CLOSED_TEXT]: CLAIM_STATUS_CLOSED,
  [CLAIM_PARTIALLY_APPROVED_TEXT]: CLAIM_STATUS_INITIATED,
};

export const CLAIM_TYPE_MOBILE_OTSR = 117;
export const CLAIM_TYPE_MOBILE_ADLD = 118;
export const CLAIM_TYPE_MOBILE_EW = 119;

export const COLOR_SUCCESS_GREEN = "successGreen";
export const COLOR_DANGER_RED = "dangerRed";
export const COMING_SOON = "Coming Soon";
export const CONFIG_ENTITY_NAME = "SERVICE_CENTER_CONFIG";
export const CREDIT_IN_DAYS = "CREDIT_IN_DAYS";
export const CURRENCY_FORMAT = "en-IN";
export const CUSTOM_DATE_RANGE = "customDateRange";
export const CUSTOMER_OTP_LENGTH = 6;

export const DASHBOARD_SECTION = "Dashboard Section";
export const DASH_SYMBOL = "-";
export const DEALER = "dealer";
export const DEALER_OTP_LENGTH = 6;
export const DEFAULT_VISA_TYPE = "non_immigrant";
export const DELAY_AVERAGE = 5000;
export const DELAY_LONG = 7000;
export const DELAY_SHORT = 3000;
export const DOWNLOAD = "Download";
export const DOWNLOADING_CERTIFICATE =
  "Downloading certificate, Please wait...";
export const DOWNLOAD_CLAIMS_TOOLTIP = "Download claims list";
export const DOCUMENT_TPYE_ID_AADHAAR = 1;
export const DOCUMENT_TPYE_ID_ESTIMATE = 15;
export const DOCUMENT_TPYE_ID_INVOICE = 16;
export const DOCUMENT_TPYE_ID_MOBILE_PHOTOS = 73;
export const DOCUMENT_TPYE_ID_REPAIRED_MOBILE_PHOTOS = 74;
export const DEFAULT_CITY_NAME = "Gurgaon";
export const DEFAULT_STATE_NAME = "Haryana";
export const DEFAULT_PINCODE = 122001;
export const DATE_OF_DAMAGE_SLUG = "date_of_damage";
export const DAMAGE_DETAILS_SLUG = "damage_details";
export const DAMAGED_CYCLE_PARTS_SLUG = "damaged_cycle_parts";
export const DAMAGED_ASSET_PARTS_LIST = [
  "Display Screen",
  "Battery",
  "Camera Lens",
  "Charging Port",
  "Speaker and Microphone",
  "SIM Card Tray",
  "Antenna",
  "Others",
];
export const DOCUMENT_CDN_PATH = process.env.REACT_APP_S3_BUCKET_URL;
//"https://toffee-cdn-qa.s3.ap-south-1.amazonaws.com/";
export const DEFAULT_TAB_INDEX = 3;
export const DOWNLOAD_CLAIM_FILE_NAME = "ClaimsList.xlsx";
export const DOWNLOAD_CLAIM_SHEET_NAME = "Sheet1";

export const END_TIME = "23:59:59";
export const ENTITY_PRODUCT = "Product";
export const ERROR_MESSAGE_TEXT =
  "It looks like something went wrong. Please try again in a while.";
export const EXPORT_LIST = "Download";
export const EXPORT_POLICY_DATA = "Export Policy Data";
export const EX_SHOWROOM_PRICE = "Invoice Amount";

export const FORMAT_DOB = "DD/MM/YYYY";
export const FORMAT_YYYY_MM_DD = "YYYY-MM-DD";
export const FORMAT_YYYY_MM_DD_HMS = "YYYY-MM-DD HH:mm:ss";
export const FORMAT_DD_MM_YYYY_HMS = "DD-MM-YYYY HH:mm:ss";
export const FORMAT_DD_MM_YYYY = "DD-MM-YYYY";

export const GB_SLUG = "GB";
export const GST_PERCENTAGE = 18;

export const HH_MM = "HH:mm";

export const INITIATE_CLAIM_TOOLTIP = "Initiate a claim on behalf of customer";

export const LABEL_PRODUCT = "Plan";
export const LABEL_COPAYMENT = "Co-payment";
export const LABEL_IMEI_NUMBER = "IMEI Number";
export const LABEL_PREFERRED = "SC (Preferred)";
export const LABEL_ESTIMATED_BY = "Estimated By";
export const LABEL_JOB_SHEET_NUMBER = "Job Sheet Number";
export const LABEL_UTR_NUMBER = "UTR Number";
export const LABEL_PARTIAL_PAYMENT = "Partial Payment";
export const DAMAGE_REMARK = "Damage Remark";

export const LAST_MONTH = "lastMonth";
export const LAST_MONTH_TEXT = "Last Month";
export const LAST_WEEK = "lastWeek";
export const LOCATION_OF_DAMAGE_SLUG = "location_of_damage";

export const MASTER_PRODUCT_ID = 74;
export const MODAL_KEY_PREMIUM = "premium";
export const MODAL_TITLE_CLAIM_REMARKS = "Claim Remarks";
export const MODAL_TITLE_DAMAGED_MOBILE_PHOTO = "Damage Mobile Photo";
export const MODAL_TITLE_ESTIMATE_PHOTO = "Estimate Document";
export const MODAL_TITLE_INVOICE_PHOTO = "Repaired Invoice Copy";
export const MODAL_TITLE_REPAIRED_MOBILE_PHOTO = "Repaired Mobile Photo";
export const MONTH_TEXT = "This Month";
export const MOTOR = "motor";

export const NO_ACTIVE_POLICY_TO_CLAIM_TEXT =
  "There is no active policy to start a new claim.";
export const NOT_AVAILABLE = "N/A";
export const NOT_AVAILABLE_TEXT = "Not Available";

export const ORDER_ID = "orderId";

export const PAYMENT_FAILED_MESSAGE =
  "There seems to be a problem in processing your payment.";
export const PAYLOAD_DOCUMENT_TPYE_ID = "document_type_id";
export const PAYLOAD_CLAIM_DOCUMENTS = "claimDocuments[]";
export const PAYLOAD_DELETE_EXISTING_DOCUMENT = "delete_existing_document";
export const PRODUCT_ID_MOBILE_ADLD = 67;
export const PRODUCT_ID_MOBILE_EW = 92;
export const PRODUCT_ID_MOBILE_OTSR = 63;
export const POLICY_SOLD = "Policies Sold";
export const PREV_X_DAYS = "previousXDays";
export const PRODUCT_ID = "productId";
export const PRODUCT_NAME = "productName";
export const PARTNER_ID_MOBILE_STACK_DEMO = 191;
export const PASSWORD_SLUG = "password";
export const PENDING_TEXT = "Pending";

export const QUERY_STRING_ISSUE_POLICY = "issue_policy";
export const QUOTES_LIST = "quotesList";

export const RANKING = "Ranking";
export const RE_UPLOAD = "Re-Upload";
export const RUPEE_SYMBOL = "₹";

export const SEARCH_BY_TEXT =
  "Search by claim reference number, customer mobile, or imei number";
export const SLUG_DAMAGED_MOBILE = "damagedMobile";
export const SLUG_ESTIMATE_MOBILE = "estimate";
export const SLUG_INVOICE_MOBILE = "invoice";
export const SLUG_OPEN = "open";
export const SLUG_REPAIRED_MOBILE = "repairedMobile";
export const SLUG_REMARK = "remark";
export const SLUG_SKIP_COPAYMENT = "SKIP_COPAYMENT";
export const SLUG_UPLOADED_DAMAGED_MOBILE = "damage_mobile_uploaded_for_claim";
export const SLUG_UPLOADED_ESTIMATE_MOBILE = "estimate_uploaded_for_claim";
export const SLUG_UPLOADED_INVOICE_MOBILE = "invoice_uploaded_for_claim";
export const SLUG_UPLOADED_REPAIRED_MOBILE =
  "repaired_mobile_uploaded_for_claim";
export const SOME_THING_WENT_WRONG_TEXT =
  "It looks like something went wrong. Please try again in a while.";
export const START_TIME = "00:00:00";
export const SOURCE_SERVICE_CENTRE = "service_centre";
export const SERVICE_CENTRE_SLUG = "service_centre";
export const SERVICE_CENTRE_ID = "service_centre_id";
export const SERVICE_CENTRE_NAME = "Service Centre Name";

export const THIS_MONTH = "thisMonth";
export const THIS_MONTH_TEXT = "This Month";
export const THIS_WEEK = "thisWeek";
export const THIS_WEEK_TEXT = "This Week";
export const THIS_YEAR_TEXT = "This Year";
export const TODAY = "today";
export const TODAY_TEXT = "Today";
export const TOTAL_EARNIGS = "Total Earnings";

export const UPLOAD = "Upload";
export const UPLOAD_REPAIRED_INVOICE_PHOTO = "Upload repaired invoice photo";
export const UPLOAD_REPAIRED_MOBILE_PHOTO = "Upload repaired phone photo";
export const USER = "user";
export const USER_DETAILS = "user_details";
export const USER_DETAILS_SLUG = "user_details";

export const VALID = "valid";
export const VEHICLE_TYPE_NEW = "NEW";
export const VEHICLE_TYPE_OLD = "OLD";

export const WEEK_TEXT = "This Week";
export const YEAR_TEXT = "This Year";
